"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var FeedItemBody = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-fdi--bd", className) }, children));
};
var FeedItemFooter = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-fdi--ft", className) }, children));
};
var FeedItem = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-fdi", className) }, children));
};
FeedItem.Body = FeedItemBody;
FeedItem.Footer = FeedItemFooter;
exports.default = FeedItem;
